import { Badge } from "@/components/ui/badge"

export default function StudyDoActivityStep() {
  return (
    <section className="flex flex-col gap-4">
      <header className="flex items-center gap-2">
        <h1 className="text-base font-bold">Realizar actividades</h1>
      </header>
      <img
        className="w-full object-contain"
        src="https://storage.googleapis.com/educabot-aec-cdn-1/tuni/product-tour/study-do-activities.gif"
      />
      <p className="text-left text-sm text-muted-foreground">
        Cada actividad es una oportunidad para seguir creciendo. Hacé clic y empezá: hay Flashcards,
        Diagnósticos, Desafíos y Lecciones, pensadas para ayudarte a reforzar lo que aprendés en tus
        materias.
      </p>
      <Badge className="-mb-12 w-fit bg-primary-50 text-primary-500">
        <span className="font-semibold">Paso 6 de 8</span>
      </Badge>
    </section>
  )
}
